import React, { useEffect, useRef } from 'react';
import { useState } from 'react';
import Tooltip from '../reusable/Tooltip';
import { useSearchParams, useNavigate, Link, useParams } from 'react-router-dom';
import axiosInstance from '../api/axiosInstance';
import OtpModal from '../modals/otpModal';
import AlertModal from '../reusable/AlertModal';
import imageCompression from 'browser-image-compression';

const locationData = [
  // Client's Home State prioritized at the top with comprehensive cities
  { 
    state: "Karnataka", 
    cities: ["Bangalore", "Mysore", "Hubli-Dharwad", "Mangalore", "Belgaum", "Gulbarga", "Davanagere", "Bellary", "Bijapur", "Shimoga", "Tumkur", "Raichur", "Bidar", "Hassan", "Udupi", "Chikmagalur", "Karwar", "Kolar", "Chitradurga", "Haveri", "Mandya", "Gadag", "Bagalkot", "Koppal", "Yadgir", "Chamrajnagar", "Ramanagara", "Chikkaballapur", "Madikeri"] 
  },
  // Alphabetical list of the remaining States & UTs
  { state: "Andaman and Nicobar Islands", cities: ["Port Blair", "Garacharma", "Bambooflat"] },
  { state: "Andhra Pradesh", cities: ["Visakhapatnam", "Vijayawada", "Guntur", "Nellore", "Kurnool"] },
  { state: "Arunachal Pradesh", cities: ["Itanagar", "Tawang", "Naharlagun", "Pasighat"] },
  { state: "Assam", cities: ["Guwahati", "Silchar", "Dibrugarh", "Jorhat", "Nagaon"] },
  { state: "Bihar", cities: ["Patna", "Gaya", "Bhagalpur", "Muzaffarpur", "Purnia"] },
  { state: "Chandigarh", cities: ["Chandigarh"] },
  { state: "Chhattisgarh", cities: ["Raipur", "Bhilai", "Bilaspur", "Korba", "Durg"] },
  { state: "Dadra and Nagar Haveli and Daman and Diu", cities: ["Daman", "Diu", "Silvassa"] },
  { state: "Delhi", cities: ["New Delhi", "North Delhi", "South Delhi", "West Delhi", "East Delhi"] },
  { state: "Goa", cities: ["Panaji", "Margao", "Vasco da Gama", "Mapusa", "Ponda"] },
  { state: "Gujarat", cities: ["Ahmedabad", "Surat", "Vadodara", "Rajkot", "Bhavnagar"] },
  { state: "Haryana", cities: ["Gurugram", "Faridabad", "Panipat", "Ambala", "Rohtak"] },
  { state: "Himachal Pradesh", cities: ["Shimla", "Manali", "Dharamshala", "Mandi", "Solan"] },
  { state: "Jammu and Kashmir", cities: ["Srinagar", "Jammu", "Anantnag", "Baramulla", "Kathua"] },
  { state: "Jharkhand", cities: ["Ranchi", "Jamshedpur", "Dhanbad", "Bokaro", "Deoghar"] },
  { state: "Kerala", cities: ["Thiruvananthapuram", "Kochi", "Kozhikode", "Thrissur", "Kollam"] },
  { state: "Ladakh", cities: ["Leh", "Kargil"] },
  { state: "Lakshadweep", cities: ["Kavaratti", "Agatti", "Minicoy"] },
  { state: "Madhya Pradesh", cities: ["Indore", "Bhopal", "Jabalpur", "Gwalior", "Ujjain"] },
  { state: "Maharashtra", cities: ["Mumbai", "Pune", "Nagpur", "Nashik", "Kolhapur", "Aurangabad", "Solapur"] },
  { state: "Manipur", cities: ["Imphal", "Thoubal", "Bishnupur", "Churachandpur"] },
  { state: "Meghalaya", cities: ["Shillong", "Tura", "Nongstoin", "Jowai"] },
  { state: "Mizoram", cities: ["Aizawl", "Lunglei", "Saiha", "Champhai"] },
  { state: "Nagaland", cities: ["Kohima", "Dimapur", "Mokokchung", "Tuensang"] },
  { state: "Odisha", cities: ["Bhubaneswar", "Cuttack", "Rourkela", "Berhampur", "Puri"] },
  { state: "Puducherry", cities: ["Puducherry", "Ozhukarai", "Karaikal", "Yanam", "Mahe"] },
  { state: "Punjab", cities: ["Ludhiana", "Amritsar", "Jalandhar", "Patiala", "Bathinda"] },
  { state: "Rajasthan", cities: ["Jaipur", "Jodhpur", "Udaipur", "Kota", "Bikaner"] },
  { state: "Sikkim", cities: ["Gangtok", "Namchi", "Gyalshing", "Mangan"] },
  { state: "Tamil Nadu", cities: ["Chennai", "Coimbatore", "Madurai", "Tiruchirappalli", "Salem"] },
  { state: "Telangana", cities: ["Hyderabad", "Warangal", "Nizamabad", "Karimnagar", "Khammam"] },
  { state: "Tripura", cities: ["Agartala", "Dharmanagar", "Udaipur", "Kailashahar"] },
  { state: "Uttar Pradesh", cities: ["Lucknow", "Kanpur", "Agra", "Varanasi", "Noida"] },
  { state: "Uttarakhand", cities: ["Dehradun", "Haridwar", "Roorkee", "Nainital", "Rishikesh"] },
  { state: "West Bengal", cities: ["Kolkata", "Howrah", "Darjeeling", "Siliguri", "Asansol"] }
];


const Registration = () => {

  // ─────────────────────────────────────────────────────────────────
  // ██████████████████  STATE DECLARATIONS  ████████████████████████
  // ─────────────────────────────────────────────────────────────────

  // --- Navigation & URL Params ---
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { refCode } = useParams();
  const urlRefCode = refCode || "";

  // --- UI / Flow Control ---
  const [loading, setLoading] = useState(false);
  const [step, setStep] = useState(1);
  const [showOTP, setShowOTP] = useState(false);
  const [isSuccessOpen, setIsSuccessOpen] = useState(false);
  const [globalAlert, setGlobalAlert] = useState({ isOpen: false, title: "", message: "" });

  // --- Password Visibility ---
  const [showPassword, setshowPassword] = useState(false);
  const [showConfirmPassword, setshowConfirmPassword] = useState(false);

  // --- Location Dropdowns ---
  const [showStateDropdown, setShowStateDropdown] = useState(false);
  const [showCityDropdown, setShowCityDropdown] = useState(false);

  // --- OTP ---
  const [requestId, setRequestId] = useState(null);
  const [otpError, setOtpError] = useState("");

  // --- Plans ---
  const [plans, setPlans] = useState([]);
  const [isFetchingPlans, setIsFetchingPlans] = useState(false);

  // --- Auth / Referral ---
  const [isAuthorizedLink, setIsAuthorizedLink] = useState(!!urlRefCode);

  // ─────────────────────────────────────────────────────────────────
  // ████████████████  USER DETAILS FORM STATE  ██████████████████████
  // ─────────────────────────────────────────────────────────────────

  const [formData, setformData] = useState({
    fullName: "",
    phone: "",
    email: "",
    address: "",
    city: "",
    state: "",
    pincode: "",
    referralID: urlRefCode,
    password: "",
    confirmPassword: "",
  });

  const [errors, setErrors] = useState({});
  const [apiError, setApiError] = useState("");

  // ─────────────────────────────────────────────────────────────────
  // ████████████████  PAYMENT FORM STATE  ███████████████████████████
  // ─────────────────────────────────────────────────────────────────

  const [paymentData, setPaymentData] = useState({
    planId: "",
    paymentAmount: "",
    paymentMethod: "",
    transactionId: "",
    senderName: "",
    paidAt: "",
    proofFile: null,
    proofPreview: null,
  });

  const [paymentErrors, setPaymentErrors] = useState({});
  const paymentProofRef = useRef(null);

  // Dynamic min/max: payment date must be within the last 30 days and not in the future
 // Dynamic min/max for the HTML datetime-local input
  // Adjusting for local timezone so the calendar matches the user's actual clock
  const getLocalISO = (date) => new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString().slice(0, 16);
  
  const now = new Date();
  const maxPaymentDate = getLocalISO(now); // Max is exactly right now
  
  const minDate = new Date(now.getTime() - (48 * 60 * 60 * 1000)); // Exactly 48 hours ago
  const minPaymentDate = getLocalISO(minDate);


  // ─────────────────────────────────────────────────────────────────
  // ████████████████  EFFECTS  ██████████████████████████████████████
  // ─────────────────────────────────────────────────────────────────

  // Auth Guard: Redirect already-logged-in users away from register
  /*useEffect(() => {
    const token = localStorage.getItem("capstonne_access_token");
    if (token) {
      navigate("/dashboard", { replace: true });
    }
  }, [navigate]);*/

  // Referral Code Guard: Sync referral code from URL or sessionStorage
  useEffect(() => {
    const savedCode = sessionStorage.getItem("pending_referral");

    if (urlRefCode) {
      setformData((prev) => ({ ...prev, referralID: urlRefCode }));
      setIsAuthorizedLink(true);
      sessionStorage.setItem("pending_referral", urlRefCode);
    } else if (savedCode) {
      setformData((prev) => ({ ...prev, referralID: savedCode }));
      setIsAuthorizedLink(true);
    } else {
      setIsAuthorizedLink(false);
    }
  }, [urlRefCode]);


  // ─────────────────────────────────────────────────────────────────
  // ████████████  USER DETAILS — LOCATION DROPDOWN LOGIC  ███████████
  // ─────────────────────────────────────────────────────────────────

  // Filter states based on what the user is typing
  const filteredStates = locationData.filter((item) =>
    item.state.toLowerCase().includes(formData.state.toLowerCase())
  );

  // Filter cities: if a state is selected, only show that state's cities;
  // otherwise search across all cities in India
  let filteredCities = [];
  if (formData.state) {
    const selectedStateObj = locationData.find((item) => item.state === formData.state);
    const availableCities = selectedStateObj ? selectedStateObj.cities : [];
    filteredCities = availableCities.filter((city) =>
      city.toLowerCase().includes(formData.city.toLowerCase())
    );
  } else {
    const allCitiesAcrossIndia = locationData.flatMap((item) => item.cities);
    filteredCities = allCitiesAcrossIndia.filter((city) =>
      city.toLowerCase().includes(formData.city.toLowerCase())
    );
  }

  // When the user selects a state from the dropdown
  const handleStateSelect = (stateName) => {
    setformData({ ...formData, state: stateName, city: "" });
    setShowStateDropdown(false);
    setErrors((prev) => ({ ...prev, state: "" }));
  };

  // When the user selects a city from the dropdown (auto-detects the state if empty)
  const handleCitySelect = (cityName) => {
    let matchedState = formData.state;
    if (!matchedState) {
      const stateObj = locationData.find((item) => item.cities.includes(cityName));
      matchedState = stateObj ? stateObj.state : "";
    }
    setformData({ ...formData, city: cityName, state: matchedState });
    setShowCityDropdown(false);
    setErrors((prev) => ({ ...prev, city: "" }));
  };


  // ─────────────────────────────────────────────────────────────────
  // ████████████  USER DETAILS — VALIDATION  ████████████████████████
  // ─────────────────────────────────────────────────────────────────

  // Real-time field-level validator (runs on every keystroke)
  const validateField = (name, value) => {
    // If the field is cleared while typing, remove the red error.
    // validateAll() will still catch empty fields on submit.
    if (value.trim() === "") return "";

    let errorMsg = "";

    switch (name) {
      case "fullName":
        if (!/^[a-zA-Z\s]+$/.test(value))
          errorMsg = "Name cannot contain numbers or special characters.";
        else if (value.trim().length <= 3)
          errorMsg = "Name must be more than 3 characters long.";
        break;

      case "phone":
        if (!/^[6-9]\d{9}$/.test(value))
          errorMsg = "Enter a valid 10-digit number starting with 6-9.";
        break;

      case "email":
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value))
          errorMsg = "Enter a valid email address.";
        break;

      case "password":
        if (
          !/^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/.test(value)
        )
          errorMsg = "Must be 8+ chars with 1 uppercase, 1 number, and 1 symbol.";
        // ✅ NOTE: confirmPassword cross-validation is handled in handleChange, NOT here.
        // Never call setErrors() inside a validator — it causes infinite re-renders.
        break;

      case "confirmPassword":
        if (value !== formData.password)
          errorMsg = "Passwords do not match.";
        break;

      case "address":
        if (value.trim().length < 5)
          errorMsg = "Please enter a complete address.";
        break;

        case "state": {
          // Use trim() to handle trailing spaces from autofill
          const trimmedValue = value.trim();
          const stateExists = locationData.some(
            (item) => item.state.toLowerCase() === trimmedValue.toLowerCase()
          );
          
          if (!trimmedValue) {
            errorMsg = "State is required.";
          } else if (!stateExists) {
            errorMsg = "Please select a valid state from the list.";
          } else {
            errorMsg = ""; // Explicitly clear the message
          }
          break;
        }
        
        case "city": {
          const trimmedValue = value.trim();
          // Better Logic: Only check cities within the ALREADY selected state
          const currentStateData = locationData.find(
            (item) => item.state.toLowerCase() === formData.state.toLowerCase()
          );
          
          const cityExists = currentStateData?.cities.some(
            (c) => c.toLowerCase() === trimmedValue.toLowerCase()
          );
        
          if (!trimmedValue) {
            errorMsg = "City is required.";
          } else if (!cityExists) {
            errorMsg = "Please select a valid city from the list.";
          } else {
            errorMsg = ""; // Explicitly clear the message
          }
          break;
        }
      case "pincode":
        if (!/^\d{6}$/.test(value))
          errorMsg = "PIN code must be exactly 6 digits.";
        break;

      case "referralID":
        if (value.trim().length < 3)
          errorMsg = "Please enter a valid Sponsor ID.";
        break;

      default:
        break;
    }

    return errorMsg;
  };

  // Full form validator — runs on "Next" / "Submit" button click
  const validateAll = () => {
    let newErrors = {};

    Object.keys(formData).forEach((key) => {
      if (formData[key].trim() === "") {
        // Convert camelCase → "Title Case" for the error message
        const formattedKey = key
          .replace(/([A-Z])/g, " $1")
          .replace(/^./, (str) => str.toUpperCase());
        newErrors[key] = `${formattedKey} is required.`;
      } else {
        const error = validateField(key, formData[key]);
        if (error) newErrors[key] = error;
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };


  // ─────────────────────────────────────────────────────────────────
  // ████████████  USER DETAILS — HANDLERS  ██████████████████████████
  // ─────────────────────────────────────────────────────────────────

  // Generic input change handler with real-time validation
  const handleChange = (e) => {
    const { name, value } = e.target;
    const updatedForm = { ...formData, [name]: value };
    setformData(updatedForm);

    // Validate the field that just changed
    const fieldError = validateField(name, value);
    const newErrors = { ...errors, [name]: fieldError };

    // Cross-validation for password fields lives HERE — never inside validateField.
    // Calling setErrors() inside a pure validator function causes infinite re-renders.
    if (name === "password" && updatedForm.confirmPassword) {
      newErrors.confirmPassword =
        value !== updatedForm.confirmPassword ? "Passwords do not match." : "";
    }

    setErrors(newErrors);
  };

  // Toggle password visibility
  const togglePassword = () => setshowPassword(!showPassword);
  const toggleConfirmPassword = () => setshowConfirmPassword(!showConfirmPassword);

  // Mask phone number for OTP screen (e.g. +91 ******7890)
  const maskPhoneNumber = (phone) => {
    if (!phone || phone.length < 4) return phone;
    const lastFour = phone.slice(-4);
    const maskedPrefix = "*".repeat(phone.length - 4);
    return `+91 ${maskedPrefix}${lastFour}`;
  };
  const isStep1Valid = () => {
    const {
      fullName, phone, email, address,
      city, state, pincode, referralID,
      password, confirmPassword,
    } = formData;
    return (
      fullName.trim().length > 3 &&
      /^[6-9]\d{9}$/.test(phone) &&
      /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) &&
      address.trim().length > 4 &&
      city !== "" &&
      state !== "" &&
      /^\d{6}$/.test(pincode) &&
      referralID.trim().length >= 3 &&
      /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/.test(password) &&
      password === confirmPassword
    );
  };
  
  const isStep2Valid = () => {
    const {
      planId, paymentAmount, paymentMethod,
      transactionId, senderName, paidAt, proofFile,
    } = paymentData;
    return (
      planId !== "" &&
      paymentAmount !== "" && Number(paymentAmount) > 0 &&
      paymentMethod !== "" &&
      transactionId.trim().length >= 5 &&
      /^[a-zA-Z0-9]+$/.test(transactionId.trim()) &&
      senderName.trim().length >= 2 &&
      paidAt !== "" &&
      proofFile !== null
    );
  };
  // "Next" button: validate Step 1, then fetch plans and move to Step 2
  const handleNextStep = async (e) => {
    e.preventDefault();

    const isValid = validateAll();
    if (!isValid) return;

    setIsFetchingPlans(true);
    try {
      const response = await axiosInstance.get("/plan/get");
      const fetchedPlans = response.data.plans || response.data || [];
      setPlans(fetchedPlans);

      // Auto-select the first plan to save the user a click
      if (fetchedPlans.length > 0) {
        setPaymentData((prev) => ({
          ...prev,
          planId: fetchedPlans[0].id,
          paymentAmount: String(Math.floor(Number(fetchedPlans[0].joining))),
        }));
      }

      setStep(2);
      window.scrollTo({ top: 0, behavior: "smooth" });
    } catch (err) {
      console.error("Failed to fetch plans:", err);
      setGlobalAlert({
        isOpen: true,
        title: "Connection Error",
        message: "Could not load subscription plans. Please try again.",
      });
    } finally {
      setIsFetchingPlans(false);
    }
  };


  // ─────────────────────────────────────────────────────────────────
  // ████████████  PAYMENT — VALIDATION  █████████████████████████████
  // ─────────────────────────────────────────────────────────────────

  // Real-time field-level validator for payment fields
  const validatePaymentField = (name, value) => {
    if (!value || (typeof value === "string" && value.trim() === "")) return "";

    switch (name) {
      case "paymentAmount":
        if (isNaN(value) || Number(value) <= 0)
          return "Amount must be a positive number.";
        break;

      case "paymentMethod":
        if (!["UPI", "Bank Transfer", "Cash"].includes(value))
          return "Please select a valid payment method.";
        break;

      case "transactionId":
        if (!/^[a-zA-Z0-9]{5,}$/.test(value.trim()))
          return "Transaction ID must be at least 5 alphanumeric characters.";
        break;

      case "senderName":
        if (!/^[a-zA-Z\s]{2,}$/.test(value.trim()))
          return "Enter a valid sender name (letters only, min 2 characters).";
        break;

        case 'paidAt': {
          const selected = new Date(value);
          const now = new Date();
          const fortyEightHoursAgo = new Date(now.getTime() - (48 * 60 * 60 * 1000));
          
          if (selected > now) {
            return 'Payment time cannot be in the future.';
          }
          if (selected < fortyEightHoursAgo) {
            return 'Payment time cannot be older than 48 hours.';
          }
          break;
        }

      default:
        break;
    }
    return "";
  };

  // Full payment form validator — runs on final submit
  const validateAllPayment = () => {
    const newErrors = {};

    if (!paymentData.paymentAmount || Number(paymentData.paymentAmount) <= 0)
      newErrors.paymentAmount = "Amount is required and must be greater than 0.";

    if (!paymentData.paymentMethod)
      newErrors.paymentMethod = "Payment method is required.";

    if (!paymentData.transactionId || paymentData.transactionId.trim().length < 5)
      newErrors.transactionId = "Transaction ID must be at least 5 alphanumeric characters.";
    else if (!/^[a-zA-Z0-9]+$/.test(paymentData.transactionId.trim()))
      newErrors.transactionId = "Transaction ID must contain only letters and numbers.";

    if (!paymentData.senderName || paymentData.senderName.trim().length < 2)
      newErrors.senderName = "Sender name is required (min 2 characters).";
    else if (!/^[a-zA-Z\s]+$/.test(paymentData.senderName.trim()))
      newErrors.senderName = "Sender name must contain letters only.";

    if (!paymentData.paidAt) {
      newErrors.paidAt = "Payment date and time is required.";
    } else {
      const selected = new Date(paymentData.paidAt);
      const now = new Date();
      // Calculate exactly 48 hours ago
      const fortyEightHoursAgo = new Date(now.getTime() - (48 * 60 * 60 * 1000));
      
      if (selected > now) {
        newErrors.paidAt = "Payment time cannot be in the future.";
      } else if (selected < fortyEightHoursAgo) {
        newErrors.paidAt = "Payment time cannot be older than 48 hours.";
      }
    }

    if (!paymentData.proofFile)
      newErrors.proof = "Please upload a payment proof screenshot.";

    setPaymentErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };


  // ─────────────────────────────────────────────────────────────────
  // ████████████  PAYMENT — HANDLERS  ███████████████████████████████
  // ─────────────────────────────────────────────────────────────────

  // Generic payment input change handler with real-time validation
  const handlePaymentChange = (e) => {
    const { name, value } = e.target;
    setPaymentData((prev) => ({ ...prev, [name]: value }));
    const err = validatePaymentField(name, value);
    setPaymentErrors((prev) => ({ ...prev, [name]: err }));
  };

  // Plan selector: auto-fills the payment amount when the user picks a plan
  // Replace entire handlePlanSelect
  const handlePlanSelect = (e) => {
    const selectedPlanId = e.target.value;
    const selectedPlan = plans.find((p) => p.id === selectedPlanId);
  
    setPaymentData((prev) => ({
      ...prev,
      planId: selectedPlanId,
      paymentAmount: selectedPlan ? String(Math.floor(Number(selectedPlan.joining))) : "",
    }));
  
    setPaymentErrors((prev) => ({ ...prev, planId: "", paymentAmount: "" }));
  };

  // Payment proof image upload: validates type/size, compresses, and previews
  const handleProofUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // 1. Validate type
    const allowedTypes = ["image/jpeg", "image/jpg", "image/png", "image/webp"];
    if (!allowedTypes.includes(file.type)) {
      setPaymentErrors((prev) => ({
        ...prev,
        proof: "Only JPG, PNG, or WEBP images are allowed.",
      }));
      return;
    }

    // 2. Validate size (max 10MB)
    if (file.size > 10 * 1024 * 1024) {
      setPaymentErrors((prev) => ({
        ...prev,
        proof: "File is too large. Maximum allowed size is 10MB.",
      }));
      return;
    }

    // 3. Compress the image (declared outside try/catch for safe scoping)
    let finalFile = file;
    try {
      const options = { maxSizeMB: 0.5, maxWidthOrHeight: 1024, useWebWorker: true };
      finalFile = await imageCompression(file, options);
    } catch (error) {
      console.error("Image compression error:", error);
      setPaymentErrors((prev) => ({
        ...prev,
        proof: "Failed to process image. Please try again.",
      }));
      return;
    }

    // 4. Create preview URL and update state
    const previewUrl = URL.createObjectURL(finalFile);
    setPaymentData((prev) => ({
      ...prev,
      proofFile: finalFile,
      proofPreview: previewUrl,
    }));
    setPaymentErrors((prev) => ({ ...prev, proof: "" }));

    // 5. Reset the file input so the same file can be re-selected if needed
    e.target.value = "";
  };


  // ─────────────────────────────────────────────────────────────────
  // ████████████  SUBMISSION — STEP 2 FINAL SUBMIT  █████████████████
  // ─────────────────────────────────────────────────────────────────

  // Sends all user + payment data to the backend; on success backend sends OTP
  const handleSubmit = async (e) => {
    e.preventDefault();
    setApiError("");

    // 1. Security check: block manual referral entry (must come from a link)
    if (formData.referralID && !isAuthorizedLink) {
      setErrors((prev) => ({
        ...prev,
        referralID: "Manual entry detected. Please use the official invite link.",
      }));
      return;
    }

    // 2. Validate all payment fields before building the payload
    const isPaymentValid = validateAllPayment();
    if (!isPaymentValid) return;

    setLoading(true);

    try {
      // 3. Compress the proof image (safety net in case handleProofUpload missed it)
      let finalProof = paymentData.proofFile;
      

      // 4. Build the FormData payload
      const fd = new FormData();

      // --- User Details ---
      fd.append("name",     formData.fullName);
      fd.append("email",    formData.email);
      fd.append("phone",    formData.phone);
      fd.append("address",  formData.address);
      fd.append("pincode",  formData.pincode);
      fd.append("city",     formData.city);
      fd.append("state",    formData.state);
      fd.append("password", formData.password);
      fd.append("refer",    formData.referralID);

      // --- Payment & Plan Details ---
      fd.append("plan",        paymentData.planId);        // ✅ key is 'plan', value is the plan id string
      fd.append("amount",      paymentData.paymentAmount); // joining fee — read from state, not from DOM
      fd.append("method",      paymentData.paymentMethod);
      fd.append("transaction", paymentData.transactionId.trim());
      fd.append("sender",      paymentData.senderName.trim());
      fd.append("paid_at",     new Date(paymentData.paidAt).toISOString());
      fd.append("proof", finalProof, "proof.jpg");
      // 5. POST to backend
      const response = await axiosInstance.post("/auth/register", fd, {
        headers: { "Content-Type": "multipart/form-data" },
        params: { ref: formData.referralID },
      });

      if (response.status === 200 || response.status === 201) {
        console.log("Registration accepted. OTP sent.: request_id:", response.data.request_id);
        console.log("Registration accepted. OTP sent.: otp:", response.data.otp_code);
        setRequestId(response.data.request_id);
        setShowOTP(true);
      }
    } catch (err) {
      console.log("BACKEND ERROR:", err.response?.data);
      const status = err.response?.status;
      const message =
        err.response?.data?.message ||
        err.response?.data?.error ||
        "Something went wrong.";

      switch (status) {
        case 400: setApiError(message); break;
        case 404: setApiError("Registration service or Sponsor not found."); break;
        case 500: setApiError("Database error. Please try again after some time."); break;
        default:  setApiError("Connection failed. Ensure the backend is running.");
      }
    } finally {
      setLoading(false);
    }
  };


  // ─────────────────────────────────────────────────────────────────
  // ████████████  OTP — VERIFY & RESEND  ████████████████████████████
  // ─────────────────────────────────────────────────────────────────

  // Verifies the OTP entered by the user; on success, submits payment proof
  const handleVerifyOTP = async (otpValue) => {
    setOtpError('');
    try {
      // 1. Send OTP to verify
      const response = await axiosInstance.post('/auth/verify', {
        request_id: requestId,
        otp: otpValue,
      });
      console.log("INCOMING OTP DATA:", response.body);
  
      if (response.status === 200 || response.status === 201) {
        
        // 2. Hide the OTP Modal
        setShowOTP(false);
        
        // 3. Optional: If the backend returns a token here for auto-login later, save it
        const token = response.data.token || response.data.access_token || response.data.accessToken;
        if (token) {
          localStorage.setItem('capstonne_access_token', token);
        }

        // 4. Registration and Payment are entirely complete! Show the Success Modal.
        setIsSuccessOpen(true);
      }
      
    } catch (err) {
      const msg = err.response?.data?.error || err.response?.data?.message || 'Invalid OTP.';
      setOtpError(msg);
      console.error("Message:", err.message);
    // Print the full error object to see column details
    console.error("Full Error:", JSON.stringify(err, null, 2)); 
    
  
      if (msg.toLowerCase().includes('expire') || msg.toLowerCase().includes('session') || msg.toLowerCase().includes('register again')) {
        setTimeout(() => {
          setShowOTP(false);
          setGlobalAlert({
            isOpen: true, 
            title: 'Session Expired', 
            message: 'Your OTP session expired. Please start registration again.'
          });
        }, 3000);
      }
    }
  };

  // Resends a fresh OTP to the user's phone
  const handleResendOTP = async () => {
    setOtpError("");

    try {
      const response = await axiosInstance.post("/auth/resend", {
        request_id: requestId,
      });

      if (response.status === 200 || response.status === 201) {
        // Update requestId if the backend issues a new one
        if (response.data.request_id) {
          setRequestId(response.data.request_id);
        }

        console.log("New OTP:", response.data.otp_code);

        setOtpError("✅ New OTP sent successfully!");
        setTimeout(() => setOtpError(""), 3000);
      }
    } catch (err) {
      console.log("BACKEND RESEND ERROR:", err.response?.data);
      const msg =
        err.response?.data?.error ||
        err.response?.data?.message ||
        "Failed to resend OTP.";

      const lowerMsg = msg.toLowerCase();
      // If the user has hit the resend limit, close the OTP modal and show a global alert
      if (
        lowerMsg.includes("limit") ||
        lowerMsg.includes("block") ||
        lowerMsg.includes("many") ||
        lowerMsg.includes("hour")
      ) {
        setShowOTP(false);
        setGlobalAlert({
          isOpen: true,
          title: "Limit Reached",
          message:
            "You have exceeded the maximum number of OTP requests. Please try again later.",
        });
      } else {
        setOtpError(msg);
      }
    }
  };


  // ─────────────────────────────────────────────────────────────────
  // ████████████████████  JSX / RENDER  █████████████████████████████
  // ─────────────────────────────────────────────────────────────────

  const selectedPlan = plans.find(p => p.id === paymentData.planId) || null;

    return (
      <section className="min-h-screen w-full bg-gray-50 p-4 md:p-8 flex items-center justify-center font-sans text-gray-800 overflow-x-hidden">
    
        <div className="max-w-6xl w-full bg-white rounded-lg shadow-md border border-gray-200 overflow-hidden flex flex-col lg:flex-row">
    
          {/* ── LEFT COLUMN ───────────────────────────────────────────────────── */}
          <div className="hidden lg:flex lg:w-5/12 bg-gradient-to-br from-indigo-600 via-indigo-700 to-slate-900 text-white p-10 md:p-16 flex-col justify-center relative overflow-hidden">
            <div className="absolute top-0 left-0 w-64 h-64 bg-white opacity-5 rounded-full -translate-x-1/2 -translate-y-1/2"></div>
            <div className="absolute bottom-0 right-0 w-96 h-96 bg-white opacity-5 rounded-full translate-x-1/3 translate-y-1/3"></div>
    
            <div className="relative z-10">
              <h2 className="text-3xl md:text-4xl font-extrabold mb-6 leading-tight tracking-tight">
                Accelerate Your <br/> Network Growth
              </h2>
              <p className="text-indigo-100 mb-8 text-lg">
                Join the elite Capstonne platform. Expand your downline seamlessly and track your 10-level deep commissions in real-time.
              </p>
              <ul className="space-y-4 text-sm font-medium text-indigo-50">
                <li className="flex items-center gap-3">
                  <span className="w-6 h-6 rounded bg-white/20 flex items-center justify-center shadow-inner text-xs">✓</span>
                  Instant Genealogy Tree
                </li>
                <li className="flex items-center gap-3">
                  <span className="w-6 h-6 rounded bg-white/20 flex items-center justify-center shadow-inner text-xs">✓</span>
                  Smart Payout Wallet
                </li>
              </ul>
    
              {/* Step indicator on left panel */}
              <div className="mt-12 space-y-3">
                <div className={`flex items-center gap-3 transition-all duration-300 ${step === 1 ? 'opacity-100' : 'opacity-40'}`}>
                  <div className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold border-2 transition-all ${step === 1 ? 'bg-white text-indigo-700 border-white' : 'border-white/40 text-white'}`}>1</div>
                  <span className="text-sm font-semibold">Personal Details</span>
                </div>
                <div className="ml-4 w-px h-4 bg-white/30"></div>
                <div className={`flex items-center gap-3 transition-all duration-300 ${step === 2 ? 'opacity-100' : 'opacity-40'}`}>
                  <div className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold border-2 transition-all ${step === 2 ? 'bg-white text-indigo-700 border-white' : 'border-white/40 text-white'}`}>2</div>
                  <span className="text-sm font-semibold">Payment Details</span>
                </div>
              </div>
            </div>
          </div>
    
          {/* ── RIGHT COLUMN ──────────────────────────────────────────────────── */}
          {/* ── RIGHT COLUMN ──────────────────────────────────────────────────── */}
        <div className="w-full lg:w-7/12 flex items-start justify-center p-4 sm:p-10 lg:p-14 overflow-y-auto overflow-x-hidden">
            <div className="w-full max-w-xl">
    
              {/* Mobile Step Pills */}
              <div className="flex lg:hidden items-center gap-2 mb-6">
                <div className={`flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-bold transition-all ${step === 1 ? 'bg-indigo-600 text-white' : 'bg-gray-100 text-gray-400'}`}>
                  <span className="w-4 h-4 rounded-full bg-white/30 flex items-center justify-center text-[10px]">1</span>
                  Personal
                </div>
                <div className="flex-1 h-px bg-gray-200"></div>
                <div className={`flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-bold transition-all ${step === 2 ? 'bg-indigo-600 text-white' : 'bg-gray-100 text-gray-400'}`}>
                  <span className="w-4 h-4 rounded-full bg-white/30 flex items-center justify-center text-[10px]">2</span>
                  Payment
                </div>
              </div>
    
              {/* ── STEP 1: REGISTRATION FORM ─────────────────────────────────── */}
              {step === 1 && (
                <>
                  <div className="mb-8">
                    <h3 className="text-2xl font-bold text-gray-900 mb-1">Create an Account</h3>
                    <p className="text-gray-500 text-sm">Fill in your details to secure your position in the network.</p>
                  </div>
    
                  <form onSubmit={handleNextStep} noValidate className="space-y-6">
    
                    {/* Full Name */}
                    <div>
                      <div className="relative group">
                        <Tooltip text="Please enter your full name here" />
                        <input required type="text" id="fullName" name="fullName" value={formData.fullName} onChange={handleChange} placeholder="e.g. Karthik Ramesh Gowda"
                          className={`peer w-full rounded-md border bg-transparent px-4 py-3 pl-10 text-gray-900 outline-none transition-all placeholder-transparent focus:placeholder-gray-400 focus:ring-1 ${errors.fullName ? 'border-red-500 focus:border-red-500 focus:ring-red-500' : 'border-gray-300 focus:border-indigo-600 focus:ring-indigo-600'}`} autoComplete="name" />
                        <label htmlFor="fullName" className={`pointer-events-none absolute left-9 top-1/2 -translate-y-1/2 bg-white px-1 transition-all duration-200 peer-valid:top-0 peer-valid:text-xs peer-focus:top-0 peer-focus:text-xs ${errors.fullName ? 'text-red-500 peer-valid:text-red-500 peer-focus:text-red-500' : 'text-gray-400 peer-valid:text-indigo-600 peer-focus:text-indigo-600'}`}>Full Name *</label>
                        <svg className={`absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 transition-colors ${errors.fullName ? 'text-red-400' : 'text-gray-400 peer-focus:text-indigo-600'}`} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path></svg>
                      </div>
                      {errors.fullName && <p className="text-red-500 text-xs mt-1.5 ml-1 font-medium">{errors.fullName}</p>}
                    </div>
    
                    {/* Phone & Email */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      <div>
                        <div className="relative group">
                          <Tooltip text="Enter a valid 10-digit mobile number starting with 6-9." />
                          <input required type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} placeholder="e.g. 98765 43210" maxLength="10"
                            className={`peer w-full rounded-md border bg-transparent px-4 py-3 pl-[4.5rem] text-gray-900 outline-none transition-all placeholder-transparent focus:placeholder-gray-400 focus:ring-1 ${errors.phone ? 'border-red-500 focus:border-red-500 focus:ring-red-500' : 'border-gray-300 focus:border-indigo-600 focus:ring-indigo-600'}`} autoComplete="tel-national" />
                          <span className="pointer-events-none absolute left-10 top-1/2 -translate-y-1/2 text-gray-500 font-medium opacity-0 transition-opacity duration-200 peer-valid:opacity-100 peer-focus:opacity-100">+91</span>
                          <label htmlFor="phone" className={`pointer-events-none absolute left-9 top-1/2 -translate-y-1/2 bg-white px-1 transition-all duration-200 peer-valid:top-0 peer-valid:text-xs peer-focus:top-0 peer-focus:text-xs ${errors.phone ? 'text-red-500 peer-valid:text-red-500 peer-focus:text-red-500' : 'text-gray-400 peer-valid:text-indigo-600 peer-focus:text-indigo-600'}`}>Phone Number *</label>
                          <svg className={`absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 transition-colors ${errors.phone ? 'text-red-400' : 'text-gray-400 peer-focus:text-indigo-600'}`} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path></svg>
                        </div>
                        {errors.phone && <p className="text-red-500 text-xs mt-1.5 ml-1 font-medium">{errors.phone}</p>}
                      </div>
                      <div>
                        <div className="relative group">
                          <Tooltip text="We will send your registration confirmation and receipts here." />
                          <input required type="email" id="email" name="email" value={formData.email} onChange={handleChange} placeholder="e.g. karthik@example.com"
                            className={`peer w-full rounded-md border bg-transparent px-4 py-3 pl-10 text-gray-900 outline-none transition-all placeholder-transparent focus:placeholder-gray-400 focus:ring-1 ${errors.email ? 'border-red-500 focus:border-red-500 focus:ring-red-500' : 'border-gray-300 focus:border-indigo-600 focus:ring-indigo-600'}`} autoComplete="email" />
                          <label htmlFor="email" className={`pointer-events-none absolute left-9 top-1/2 -translate-y-1/2 bg-white px-1 transition-all duration-200 peer-valid:top-0 peer-valid:text-xs peer-focus:top-0 peer-focus:text-xs ${errors.email ? 'text-red-500 peer-valid:text-red-500 peer-focus:text-red-500' : 'text-gray-400 peer-valid:text-indigo-600 peer-focus:text-indigo-600'}`}>Email Address *</label>
                          <svg className={`absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 transition-colors ${errors.email ? 'text-red-400' : 'text-gray-400 peer-focus:text-indigo-600'}`} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path></svg>
                        </div>
                        {errors.email && <p className="text-red-500 text-xs mt-1.5 ml-1 font-medium">{errors.email}</p>}
                      </div>
                    </div>
    
                    {/* Password & Confirm */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      <div className="relative flex flex-col">
                        <div className="relative group">
                          <Tooltip text="Must be 8+ characters with at least 1 uppercase, 1 number, and 1 symbol." />
                          <input required type={showPassword ? "text" : "password"} id="password" name="password" value={formData.password} onChange={handleChange} placeholder=" "
                            className={`peer w-full rounded-md border bg-transparent px-4 py-3 pl-10 pr-10 text-gray-900 outline-none transition-all focus:ring-1 ${errors.password ? 'border-red-500 focus:border-red-500 focus:ring-red-500' : 'border-gray-300 focus:border-indigo-600 focus:ring-indigo-600'}`} autoComplete="new-password" />
                          <label htmlFor="password" className={`pointer-events-none absolute left-9 transition-all duration-200 px-1 bg-white ${(formData.password || errors.password) ? '-top-2 text-xs' : 'top-1/2 -translate-y-1/2 text-base'} peer-focus:-top-2 peer-focus:text-xs ${errors.password ? 'text-red-500' : 'text-gray-400 peer-focus:text-indigo-600'}`}>Password *</label>
                          <svg className={`absolute left-3 top-[18px] w-5 h-5 transition-colors ${errors.password ? 'text-red-400' : 'text-gray-400 peer-focus:text-indigo-600'}`} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"></path></svg>
                          <button type="button" onClick={togglePassword} className="absolute right-3 top-[18px] text-gray-400 hover:text-indigo-600 focus:outline-none">
                            {showPassword ? (<svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88L1 1m11 11L22 22"></path></svg>) : (<svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"></path></svg>)}
                          </button>
                        </div>
                        {errors.password && <p className="text-red-500 text-xs mt-1.5 ml-1 font-medium">{errors.password}</p>}
                      </div>
                      <div className="relative flex flex-col">
                        <div className="relative group">
                          <Tooltip text="Re-enter your password exactly as typed above." />
                          <input required type={showConfirmPassword ? "text" : "password"} id="confirmPassword" name="confirmPassword" value={formData.confirmPassword} onChange={handleChange} placeholder=" "
                            className={`peer w-full rounded-md border bg-transparent px-4 py-3 pl-10 pr-10 text-gray-900 outline-none transition-all focus:ring-1 ${errors.confirmPassword ? 'border-red-500 focus:border-red-500 focus:ring-red-500' : 'border-gray-300 focus:border-indigo-600 focus:ring-indigo-600'}`} autoComplete="new-password" />
                          <label htmlFor="confirmPassword" className={`pointer-events-none absolute left-9 transition-all duration-200 px-1 bg-white ${(formData.confirmPassword || errors.confirmPassword) ? '-top-2 text-xs' : 'top-1/2 -translate-y-1/2 text-base'} peer-focus:-top-2 peer-focus:text-xs ${errors.confirmPassword ? 'text-red-500' : 'text-gray-400 peer-focus:text-indigo-600'}`}>Confirm Password *</label>
                          <svg className={`absolute left-3 top-[18px] w-5 h-5 transition-colors ${errors.confirmPassword ? 'text-red-400' : 'text-gray-400 peer-focus:text-indigo-600'}`} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"></path></svg>
                          <button type="button" onClick={toggleConfirmPassword} className="absolute right-3 top-[18px] text-gray-400 hover:text-indigo-600 focus:outline-none">
                            {showConfirmPassword ? (<svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88L1 1m11 11L22 22"></path></svg>) : (<svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"></path></svg>)}
                          </button>
                        </div>
                        {errors.confirmPassword && <p className="text-red-500 text-xs mt-1.5 ml-1 font-medium">{errors.confirmPassword}</p>}
                      </div>
                    </div>
    
                    {/* Address */}
                    <div>
                      <div className="relative group">
                        <Tooltip text="Include your flat/house number, building name, street, and area." />
                        <input required type="text" id="address" name="address" value={formData.address} onChange={handleChange} placeholder="e.g. Flat 204, Brigade Gateway"
                          className={`peer w-full rounded-md border bg-transparent px-4 py-3 pl-10 text-gray-900 outline-none transition-all placeholder-transparent focus:placeholder-gray-400 focus:ring-1 ${errors.address ? 'border-red-500 focus:border-red-500 focus:ring-red-500' : 'border-gray-300 focus:border-indigo-600 focus:ring-indigo-600'}`} autoComplete="street-address" />
                        <label htmlFor="address" className={`pointer-events-none absolute left-9 top-1/2 -translate-y-1/2 bg-white px-1 transition-all duration-200 peer-valid:top-0 peer-valid:text-xs peer-focus:top-0 peer-focus:text-xs ${errors.address ? 'text-red-500 peer-valid:text-red-500 peer-focus:text-red-500' : 'text-gray-400 peer-valid:text-indigo-600 peer-focus:text-indigo-600'}`}>Full Address *</label>
                        <svg className={`absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 transition-colors ${errors.address ? 'text-red-400' : 'text-gray-400 peer-focus:text-indigo-600'}`} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"></path></svg>
                      </div>
                      {errors.address && <p className="text-red-500 text-xs mt-1.5 ml-1 font-medium">{errors.address}</p>}
                    </div>
    
                    {/* State & City */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      <div>
                        <div className="relative group">
                          <Tooltip text="Type to search and click a state from the dropdown list." />
                          <input required type="text" id="state" name="state" value={formData.state} onChange={handleChange} onFocus={() => setShowStateDropdown(true)} onBlur={() => setShowStateDropdown(false)} placeholder="e.g. Karnataka"
                            className={`peer w-full rounded-md border bg-transparent px-4 py-3 pl-10 text-gray-900 outline-none transition-all placeholder-transparent focus:placeholder-gray-400 focus:ring-1 ${errors.state ? 'border-red-500 focus:border-red-500 focus:ring-red-500' : 'border-gray-300 focus:border-indigo-600 focus:ring-indigo-600'}`} autoComplete="off" />
                          <label htmlFor="state" className={`pointer-events-none absolute left-9 top-1/2 -translate-y-1/2 bg-white px-1 transition-all duration-200 peer-valid:top-0 peer-valid:text-xs peer-focus:top-0 peer-focus:text-xs ${errors.state ? 'text-red-500 peer-valid:text-red-500 peer-focus:text-red-500' : 'text-gray-400 peer-valid:text-indigo-600 peer-focus:text-indigo-600'}`}>Search State *</label>
                          <svg className={`absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 transition-colors ${errors.state ? 'text-red-400' : 'text-gray-400 peer-focus:text-indigo-600'}`} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                          {showStateDropdown && filteredStates.length > 0 && (
                            <ul className="absolute z-20 w-full mt-1 bg-white border border-gray-200 rounded-md shadow-lg max-h-48 overflow-y-auto">
                              {filteredStates.map((item, index) => (
                                <li key={index} onMouseDown={() => handleStateSelect(item.state)} className="px-4 py-2 text-gray-700 hover:bg-indigo-50 hover:text-indigo-700 cursor-pointer transition-colors border-b border-gray-50 last:border-none">{item.state}</li>
                              ))}
                            </ul>
                          )}
                        </div>
                        {errors.state && <p className="text-red-500 text-xs mt-1.5 ml-1 font-medium">{errors.state}</p>}
                      </div>
                      <div>
                        <div className="relative group">
                          <Tooltip text="Type to search and click your city from the dropdown list." />
                          <input required type="text" id="city" name="city" value={formData.city} onChange={handleChange} onFocus={() => setShowCityDropdown(true)} onBlur={() => setShowCityDropdown(false)} placeholder="e.g. Bangalore"
                            className={`peer w-full rounded-md border bg-transparent px-4 py-3 pl-10 text-gray-900 outline-none transition-all placeholder-transparent focus:placeholder-gray-400 focus:ring-1 ${errors.city ? 'border-red-500 focus:border-red-500 focus:ring-red-500' : 'border-gray-300 focus:border-indigo-600 focus:ring-indigo-600'}`} autoComplete="off" />
                          <label htmlFor="city" className={`pointer-events-none absolute left-9 top-1/2 -translate-y-1/2 bg-white px-1 transition-all duration-200 peer-valid:top-0 peer-valid:text-xs peer-focus:top-0 peer-focus:text-xs ${errors.city ? 'text-red-500 peer-valid:text-red-500 peer-focus:text-red-500' : 'text-gray-400 peer-valid:text-indigo-600 peer-focus:text-indigo-600'}`}>Search City *</label>
                          <svg className={`absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 transition-colors ${errors.city ? 'text-red-400' : 'text-gray-400 peer-focus:text-indigo-600'}`} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"></path></svg>
                          {showCityDropdown && filteredCities.length > 0 && (
                            <ul className="absolute z-20 w-full mt-1 bg-white border border-gray-200 rounded-md shadow-lg max-h-48 overflow-y-auto">
                              {filteredCities.map((city, index) => (
                                <li key={index} onMouseDown={() => handleCitySelect(city)} className="px-4 py-2 text-gray-700 hover:bg-indigo-50 hover:text-indigo-700 cursor-pointer transition-colors border-b border-gray-50 last:border-none">{city}</li>
                              ))}
                            </ul>
                          )}
                        </div>
                        {errors.city && <p className="text-red-500 text-xs mt-1.5 ml-1 font-medium">{errors.city}</p>}
                      </div>
                    </div>
    
                    {/* PIN & Referral */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      <div>
                        <div className="relative group">
                          <Tooltip text="Enter your exact 6-digit postal code." />
                          <input required type="text" inputMode="numeric" pattern="[0-9]*" maxLength="6" id="pincode" name="pincode" value={formData.pincode} onChange={handleChange} placeholder="e.g. 560001"
                            className={`peer w-full rounded-md border bg-transparent px-4 py-3 pl-10 text-gray-900 outline-none transition-all placeholder-transparent focus:placeholder-gray-400 focus:ring-1 ${errors.pincode ? 'border-red-500 focus:border-red-500 focus:ring-red-500' : 'border-gray-300 focus:border-indigo-600 focus:ring-indigo-600'}`} autoComplete="postal-code" />
                          <label htmlFor="pincode" className={`pointer-events-none absolute left-9 top-1/2 -translate-y-1/2 bg-white px-1 transition-all duration-200 peer-valid:top-0 peer-valid:text-xs peer-focus:top-0 peer-focus:text-xs ${errors.pincode ? 'text-red-500 peer-valid:text-red-500 peer-focus:text-red-500' : 'text-gray-400 peer-valid:text-indigo-600 peer-focus:text-indigo-600'}`}>PIN Code *</label>
                          <svg className={`absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 transition-colors ${errors.pincode ? 'text-red-400' : 'text-gray-400 peer-focus:text-indigo-600'}`} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.243-4.243a8 8 0 1111.314 0z"></path><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"></path></svg>
                        </div>
                        {errors.pincode && <p className="text-red-500 text-xs mt-1.5 ml-1 font-medium">{errors.pincode}</p>}
                      </div>
                      <div>
                        <div className="relative group">
                          <Tooltip text={urlRefCode ? "Referral code applied." : "An invitation link is required."} />
                          <input required type="text" id="referralID" name="referralID" value={formData.referralID} readOnly={isAuthorizedLink} placeholder=" "
                            className={`peer w-full rounded-md border px-4 py-3 pl-10 text-gray-900 outline-none transition-all bg-gray-50 border-gray-300 cursor-not-allowed ${errors.referralID ? 'border-red-500' : ''}`} />
                          <label htmlFor="referralID" className={`pointer-events-none absolute left-9 transition-all duration-200 px-1 ${formData.referralID ? '-top-2 text-xs bg-white text-gray-500' : 'top-1/2 -translate-y-1/2 text-base text-gray-400'}`}>Referral ID *</label>
                          <svg className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"></path></svg>
                        </div>
                        {errors.referralID && <p className="text-red-500 text-xs mt-1.5 ml-1 font-medium">{errors.referralID}</p>}
                        {!urlRefCode && <p className="text-amber-600 text-[10px] mt-1.5 ml-1 font-medium italic">⚠️ Registration requires a valid invite link.</p>}
                      </div>
                    </div>
    
                    {/* Next Button */}
                    {/* Next Button */}
                    <div className="pt-2">
                      <button 
                        type="button" 
                        disabled={!isStep1Valid() || isFetchingPlans}
                        onClick={handleNextStep}
                        className={`w-full py-3.5 rounded-md font-semibold text-base transition-all flex items-center justify-center gap-2 text-white
                          ${(!isStep1Valid() || isFetchingPlans) 
                            ? 'bg-indigo-300 shadow-none cursor-not-allowed' 
                            : 'bg-indigo-600 hover:bg-indigo-700 shadow-sm hover:shadow-md active:scale-[0.98]'
                          }`}
                      >
                        {isFetchingPlans ? (
                          <>
                            <svg className="animate-spin h-5 w-5 text-white" fill="none" viewBox="0 0 24 24">
                              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                            </svg>
                            Fetching Plans...
                          </>
                        ) : (
                          <>
                            Next: Select Plan & Payment
                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M13 7l5 5m0 0l-5 5m5-5H6"></path>
                            </svg>
                          </>
                        )}
                      </button>
                    </div>
    
                    <div className="text-center mt-6">
                      <p className="text-sm text-gray-600">
                        Already have an account?{' '}
                        <Link to="/login" className="font-semibold text-indigo-600 hover:text-indigo-800 transition-colors">Login</Link>
                      </p>
                    </div>
    
                  </form>
                </>
              )}
    
    {step === 2 && (
                <div className="animate-in fade-in slide-in-from-right-4 duration-300">
                  
                  {/* ── 1. HEADER & BACK BUTTON (Single Row, Slightly Larger) ── */}
                  <div className="flex items-center justify-between mb-5">
                    <div>
                      <h3 className="text-2xl font-bold text-gray-900 leading-tight">Payment Details</h3>
                      <p className="text-gray-500 text-sm mt-0.5">Provide proof for admin verification.</p>
                    </div>
                    <button 
                      type="button" 
                      onClick={() => setStep(1)} 
                      className="flex items-center gap-1.5 text-sm font-bold text-indigo-600 hover:text-indigo-800 bg-indigo-50 hover:bg-indigo-100 px-3.5 py-2 rounded-md transition-colors group"
                    >
                      <svg className="w-4 h-4 group-hover:-translate-x-0.5 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M11 17l-5-5m0 0l5-5m-5 5h12"></path></svg>
                      Back
                    </button>
                  </div>
    
                  {/* ── 2. INFO BANNER (More padding, larger icon) ── */}
                  <div className="flex items-center gap-3 p-3.5 rounded-md bg-indigo-50 border border-indigo-200 mb-6">
                    <svg className="w-5 h-5 text-indigo-600 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                    <p className="text-sm text-indigo-800 font-medium">
                      Registration fee required. Account activates post-approval.
                    </p>
                  </div>
    
                  <form onSubmit={handleSubmit} noValidate className="space-y-5">
    
                    {/* ── PLAN SELECTION ── */}
                    <div>
                      <div className="relative group">
                        <Tooltip text="Select your registration plan." />
                        <select required id="planId" name="planId" value={paymentData.planId} onChange={handlePlanSelect}
                          className={`peer w-full rounded-md border bg-transparent px-4 py-3 pl-10 text-gray-900 outline-none transition-all focus:ring-1 cursor-pointer appearance-none ${paymentErrors.planId ? 'border-red-500 focus:border-red-500 focus:ring-red-500' : 'border-gray-300 focus:border-indigo-600 focus:ring-indigo-600'}`}
                        >
                          <option value="" disabled hidden></option>
                          {plans.map(plan => (
                            <option key={plan.id} value={plan.id}>{plan.name} — ₹{plan.joining} joining</option>
                          ))}
                        </select>
                        <label htmlFor="planId" className={`pointer-events-none absolute left-9 transition-all duration-200 px-1 bg-white ${paymentData.planId ? '-top-2 text-xs' : 'top-1/2 -translate-y-1/2 text-base'} peer-focus:-top-2 peer-focus:text-xs ${paymentErrors.planId ? 'text-red-500' : 'text-gray-400 peer-focus:text-indigo-600'}`}>Registration Plan *</label>
                        <svg className={`absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 pointer-events-none ${paymentErrors.planId ? 'text-red-400' : 'text-gray-400'}`} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" /></svg>
                        <svg className="absolute right-4 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400 pointer-events-none" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" /></svg>
                      </div>
                      {paymentErrors.planId && <p className="text-red-500 text-xs mt-1.5 ml-1 font-medium">{paymentErrors.planId}</p>}
                    </div>

                    {/* ── PLAN DETAILS CARD ── */}
                    {typeof selectedPlan !== 'undefined' && selectedPlan && (
                      <div className="grid grid-cols-3 gap-3 p-3 rounded-md bg-indigo-50 border border-indigo-200">
                        <div className="flex flex-col items-center justify-center p-2 bg-white rounded-md border border-indigo-100 shadow-sm">
                          <p className="text-[10px] font-bold text-indigo-400 uppercase tracking-wide">Joining Fees</p>
                          <p className="text-base font-bold text-indigo-700">₹{Math.floor(Number(selectedPlan.joining))}</p>
                        </div>
                        <div className="flex flex-col items-center justify-center p-2 bg-white rounded-md border border-indigo-100 shadow-sm">
                          <p className="text-[10px] font-bold text-indigo-400 uppercase tracking-wide">Total Fees</p>
                          <p className="text-base font-bold text-indigo-700">₹{Math.floor(Number(selectedPlan.total))}</p>
                        </div>
                        <div className="flex flex-col items-center justify-center p-2 bg-white rounded-md border border-indigo-100 shadow-sm">
                          <p className="text-[10px] font-bold text-indigo-400 uppercase tracking-wide">Installments</p>
                          <p className="text-base font-bold text-indigo-700">{selectedPlan.duration}</p>
                        </div>
                      </div>
                    )}
    
                    {/* ── AMOUNT & METHOD (Grid) ── */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                      {/* Amount */}
                      <div>
                        <div className="relative group">
                          <Tooltip text="Joining fee is auto-filled." />
                          <input type="text" id="paymentAmount" name="paymentAmount" value={paymentData.paymentAmount ? `₹ ${paymentData.paymentAmount}` : ""} readOnly tabIndex={-1} aria-hidden="true" placeholder=" "
                            className="peer w-full rounded-md border px-4 py-3 pl-10 text-gray-900 outline-none bg-gray-100 border-gray-300 cursor-not-allowed select-none" />
                          <label htmlFor="paymentAmount" className={`pointer-events-none absolute left-9 bg-white px-1 transition-all duration-200 ${paymentData.paymentAmount ? '-top-2 text-xs' : 'top-1/2 -translate-y-1/2 text-base'} text-gray-400`}>Joining Amount *</label>
                          <svg className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
                        </div>
                        {paymentErrors.paymentAmount && <p className="text-red-500 text-xs mt-1.5 ml-1 font-medium">{paymentErrors.paymentAmount}</p>}
                      </div>
                      
                      {/* Method */}
                      <div>
                        <div className="relative group">
                          <Tooltip text="Select the payment method you used." />
                          <select id="paymentMethod" name="paymentMethod" value={paymentData.paymentMethod} onChange={handlePaymentChange}
                            className={`peer w-full rounded-md border bg-transparent px-4 py-3 pl-10 text-gray-900 outline-none transition-all focus:ring-1 cursor-pointer appearance-none ${paymentErrors.paymentMethod ? 'border-red-500 focus:ring-red-500' : 'border-gray-300 focus:border-indigo-600 focus:ring-indigo-600'}`}>
                            <option value="" disabled hidden></option>
                            <option value="UPI">UPI / QR</option>
                            <option value="Bank Transfer">Bank Transfer</option>
                            <option value="Cash">Cash</option>
                          </select>
                          <label htmlFor="paymentMethod" className={`pointer-events-none absolute left-9 transition-all duration-200 px-1 bg-white ${paymentData.paymentMethod ? '-top-2 text-xs' : 'top-1/2 -translate-y-1/2 text-base'} peer-focus:-top-2 peer-focus:text-xs ${paymentErrors.paymentMethod ? 'text-red-500' : 'text-gray-400 peer-focus:text-indigo-600'}`}>Payment Method *</label>
                          <svg className={`absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 pointer-events-none ${paymentErrors.paymentMethod ? 'text-red-400' : 'text-gray-400'}`} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" /></svg>
                          <svg className="absolute right-4 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400 pointer-events-none" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" /></svg>
                        </div>
                        {paymentErrors.paymentMethod && <p className="text-red-500 text-xs mt-1.5 ml-1 font-medium">{paymentErrors.paymentMethod}</p>}
                      </div>
                    </div>

                    {/* ── TXN ID & SENDER NAME (Grid) ── */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                      {/* TXN ID */}
                      <div>
                        <div className="relative group">
                          <Tooltip text="Transaction/UTR number from receipt." />
                          <input required type="text" minLength="5" id="transactionId" name="transactionId" value={paymentData.transactionId} onChange={handlePaymentChange} placeholder="TXN12345"
                            className={`peer w-full rounded-md border bg-transparent px-4 py-3 pl-10 text-gray-900 font-mono outline-none transition-all placeholder-transparent focus:placeholder-gray-400 focus:ring-1 ${paymentErrors.transactionId ? 'border-red-500 focus:ring-red-500' : 'border-gray-300 focus:border-indigo-600 focus:ring-indigo-600'}`} />
                          <label htmlFor="transactionId" className={`pointer-events-none absolute left-9 top-1/2 -translate-y-1/2 bg-white px-1 transition-all duration-200 peer-valid:top-0 peer-valid:text-xs peer-focus:top-0 peer-focus:text-xs font-sans ${paymentErrors.transactionId ? 'text-red-500' : 'text-gray-400 peer-focus:text-indigo-600'}`}>TXN ID / UTR *</label>
                          <svg className={`absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 transition-colors ${paymentErrors.transactionId ? 'text-red-400' : 'text-gray-400'}`} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"></path></svg>
                        </div>
                        {paymentErrors.transactionId && <p className="text-red-500 text-xs mt-1.5 ml-1 font-medium">{paymentErrors.transactionId}</p>}
                      </div>
                      
                      {/* Sender Name */}
                      <div>
                        <div className="relative group">
                          <Tooltip text="Account holder who made the payment." />
                          <input required type="text" id="senderName" name="senderName" value={paymentData.senderName} onChange={handlePaymentChange} placeholder="Name"
                            className={`peer w-full rounded-md border bg-transparent px-4 py-3 pl-10 text-gray-900 outline-none transition-all placeholder-transparent focus:placeholder-gray-400 focus:ring-1 ${paymentErrors.senderName ? 'border-red-500 focus:ring-red-500' : 'border-gray-300 focus:border-indigo-600 focus:ring-indigo-600'}`} />
                          <label htmlFor="senderName" className={`pointer-events-none absolute left-9 top-1/2 -translate-y-1/2 bg-white px-1 transition-all duration-200 peer-valid:top-0 peer-valid:text-xs peer-focus:top-0 peer-focus:text-xs ${paymentErrors.senderName ? 'text-red-500' : 'text-gray-400 peer-focus:text-indigo-600'}`}>Sender Name *</label>
                          <svg className={`absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 transition-colors ${paymentErrors.senderName ? 'text-red-400' : 'text-gray-400'}`} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path></svg>
                        </div>
                        {paymentErrors.senderName && <p className="text-red-500 text-xs mt-1.5 ml-1 font-medium">{paymentErrors.senderName}</p>}
                      </div>
                    </div>

                    {/* ── DATE OF PAYMENT ── */}
                    <div>
                      <div className="relative group">
                        <Tooltip text="Date and time when the payment was made." />
                        <input required type="datetime-local" id="paidAt" name="paidAt" value={paymentData.paidAt} onChange={handlePaymentChange} min={minPaymentDate} max={maxPaymentDate}
                          className={`peer w-full rounded-md border bg-transparent px-4 py-3 pl-10 text-gray-900 outline-none transition-all focus:ring-1 ${paymentErrors.paidAt ? 'border-red-500 focus:ring-red-500' : 'border-gray-300 focus:border-indigo-600 focus:ring-indigo-600'}`} />
                        <label htmlFor="paidAt" className={`pointer-events-none absolute left-9 -top-2 text-xs bg-white px-1 ${paymentErrors.paidAt ? 'text-red-500' : 'text-indigo-600'}`}>Date of Payment *</label>
                        <svg className={`absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 pointer-events-none ${paymentErrors.paidAt ? 'text-red-400' : 'text-gray-400'}`} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path></svg>
                      </div>
                      {paymentErrors.paidAt && <p className="text-red-500 text-xs mt-1.5 ml-1 font-medium">{paymentErrors.paidAt}</p>}
                    </div>
    
                    {/* ── PROOF UPLOAD ── */}
                    <div>
                      <div className={`flex items-center gap-3 p-3 rounded-md border ${paymentErrors.proof ? 'border-red-400 bg-red-50' : 'border-gray-200 bg-gray-50'}`}>
                        <div className="flex-1 min-w-0">
                          {paymentData.proofFile ? (
                            <div className="flex items-center gap-3">
                              <img src={paymentData.proofPreview} alt="proof" className="w-12 h-12 object-cover rounded border border-gray-200 flex-shrink-0" />
                              <div className="min-w-0">
                                <p className="text-sm font-bold text-gray-700 truncate">{paymentData.proofFile.name}</p>
                                <p className="text-xs text-gray-500">{(paymentData.proofFile.size / 1024 / 1024).toFixed(2)} MB</p>
                              </div>
                            </div>
                          ) : (
                            <p className="text-sm text-gray-500 font-medium pl-2">Payment Screenshot *</p>
                          )}
                        </div>

                        <div className="flex items-center gap-2 flex-shrink-0">
                          
                          {/* 1. Eye (View) Button */}
                          {paymentData.proofPreview && (
                            <a href={paymentData.proofPreview} target="_blank" rel="noopener noreferrer" title="View Image" className="flex items-center justify-center text-indigo-600 hover:text-indigo-800 bg-indigo-50 hover:bg-indigo-100 p-2.5 rounded-md transition-colors border border-indigo-100">
                              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" /></svg>
                            </a>
                          )}

                          {/* 2. Upload / Change Button */}
                          <button type="button" onClick={() => paymentProofRef.current.click()} className="flex items-center gap-1.5 text-xs font-bold text-white bg-indigo-600 hover:bg-indigo-700 px-3.5 py-2.5 rounded-md transition-colors shadow-sm">
                            {paymentData.proofFile ? "Change" : "Upload"}
                          </button>

                          {/* 3. Remove Button */}
                          {paymentData.proofFile && (
                            <button type="button" onClick={() => setPaymentData(p => ({ ...p, proofFile: null, proofPreview: null }))} className="flex items-center justify-center text-red-600 hover:text-red-700 bg-red-50 hover:bg-red-100 p-2.5 rounded-md transition-colors border border-red-100">
                              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M6 18L18 6M6 6l12 12" /></svg>
                            </button>
                          )}
                        </div>
                      </div>
                      <input type="file" ref={paymentProofRef} onChange={handleProofUpload} accept="image/png, image/jpeg, image/jpg, image/webp" className="hidden" />
                      {paymentErrors.proof && <p className="text-red-500 text-xs mt-1.5 ml-1 font-medium">{paymentErrors.proof}</p>}
                    </div>
    
                    {/* ── API ERROR (If any) ── */}
                    {apiError && (
                      <div className="p-4 rounded-md flex items-start gap-3 bg-red-50 border border-red-200 text-red-700">
                        <svg className="w-5 h-5 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" /></svg>
                        <div>
                          <p className="text-sm font-bold">Registration Failed</p>
                          <p className="text-xs opacity-90 mt-0.5">{apiError}</p>
                        </div>
                      </div>
                    )}
    
                    {/* ── SUBMIT BUTTON ── */}
                    <div className="pt-2">
                      <button 
                        type="submit" 
                        disabled={loading || !isStep2Valid()}
                        className={`w-full py-3.5 rounded-md font-semibold text-base transition-all flex items-center justify-center gap-2 text-white
                          ${(loading || !isStep2Valid()) 
                            ? 'bg-indigo-300 cursor-not-allowed shadow-none' 
                            : 'bg-indigo-600 hover:bg-indigo-700 shadow-sm hover:shadow-md active:scale-[0.98]'
                          }`}
                      >
                        {loading ? (
                          <>
                            <svg className="animate-spin h-5 w-5 text-white" viewBox="0 0 24 24">
                              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none"></circle>
                              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                            </svg>
                            Processing...
                          </>
                        ) : "Complete Registration"}
                      </button>
                    </div>
    
                  </form>
                </div>
              )}
            </div>
          </div>
    
        </div>
    
        {/* OTP Modal */}
        <OtpModal
          isOpen={showOTP}
          onClose={() => { setShowOTP(false); setOtpError(""); }}
          phoneNumber={maskPhoneNumber(formData.phone)}
          apiError={otpError}
          onVerify={handleVerifyOTP}
          onResend={handleResendOTP}
        />
    
        {/* ── SUCCESS MODAL ─────────────────────────────────────────────────── */}
        {isSuccessOpen && (
          <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4 bg-gray-900/70 backdrop-blur-sm">
            <div className="bg-white w-full max-w-md rounded-lg shadow-2xl overflow-hidden border border-gray-100 animate-in zoom-in-95 fade-in duration-300">
    
              {/* Green top bar */}
              <div className="h-1.5 w-full bg-gradient-to-r from-green-400 to-emerald-500"></div>
    
              <div className="p-8 flex flex-col items-center text-center">
                {/* Animated checkmark */}
                <div className="w-20 h-20 rounded-full bg-green-50 border-2 border-green-200 flex items-center justify-center mb-5">
                  <svg className="w-10 h-10 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M5 13l4 4L19 7" />
                  </svg>
                </div>
    
                <h3 className="text-2xl font-extrabold text-gray-900 mb-2 tracking-tight">Registration Submitted!</h3>
                <p className="text-sm font-medium text-gray-500 leading-relaxed max-w-sm mb-6">
                  Your registration and payment details have been securely submitted. Kindly wait for admin approval, you will be notified once your account is activated.
                </p>
    
                {/* Info cards */}
                <div className="w-full grid grid-cols-2 gap-3 mb-6">
                  <div className="rounded-md p-3 bg-gray-50 border border-gray-100 text-left">
                    <p className="text-[10px] font-bold text-gray-400 uppercase tracking-wider mb-1">Status</p>
                    <p className="text-sm font-bold text-amber-600">Pending Approval</p>
                  </div>
                  <div className="rounded-md p-3 bg-gray-50 border border-gray-100 text-left">
                    <p className="text-[10px] font-bold text-gray-400 uppercase tracking-wider mb-1">Next Step</p>
                    <p className="text-sm font-bold text-gray-700">Check SMS for Update</p>
                  </div>
                </div>
    
                <button
                  onClick={() => navigate('/login')}
                  className="w-full py-3.5 rounded-md font-bold text-white bg-indigo-600 hover:bg-indigo-700 transition-colors shadow-md active:scale-[0.98] text-sm"
                >
                  Go to Login
                </button>
              </div>
            </div>
          </div>
        )}
    
        <AlertModal
          isOpen={globalAlert.isOpen}
          title={globalAlert.title}
          message={globalAlert.message}
          onClose={() => setGlobalAlert({ ...globalAlert, isOpen: false })}
        />
      </section>
    );

};



export default Registration;